import { BaseEntity } from '../base-entity';

export class FormCd001LimpezaFilter extends BaseEntity {
    // tslint:disable-next-line: variable-name
    safra: string;
    // tslint:disable-next-line: variable-name
    site: string;
    // tslint:disable-next-line: variable-name
    hibrido: string;
    // tslint:disable-next-line: variable-name
    numero_controle: number;
    // tslint:disable-next-line: variable-name
    lote_origem: string;
    // tslint:disable-next-line: variable-name
    deposito_origem: string;
    // tslint:disable-next-line: variable-name
    is_incomplete: boolean;
    // tslint:disable-next-line: variable-name
    usuario: string;
}
